async function setServiceArchiveState(axios, service, item, archive) {
    const id = item.id;

    switch (service) {
        case 'partners':
            return axios.put(`/partners/${id}`, { ...item, archive });
        case 'restaurants': {
            const { data } = await axios.get(`/restaurants/${id}`);
            return axios.post(`/restaurants/update/${id}`, { ...data, archive });
        }
        case 'grocers':
            return axios.put(`/grocers/${id}`, { archive });
        case 'pharmacies':
            return axios.put(`/pharmacies/${id}`, { ...item, archive });
        case 'assistants':
            return axios.put(`/assistants/${id}`, { ...item, archive });
        default:
            if (service.startsWith('entities/')) {
                const { data } = await axios.get(`/entities/get/${id}`);
                return axios.post(`/entities/update/${id}`, { ...data, archive });
            }
            throw new Error(`Unknown service: ${service}`);
    }
}

export async function archiveServiceItem(axios, service, item) {
    return setServiceArchiveState(axios, service, item, true);
}

export async function unarchiveServiceItem(axios, service, item) {
    return setServiceArchiveState(axios, service, item, false);
}
